import { NumberFormatToNode } from "../../../../global";
import { SingletonEnginnering } from "../../../flowchart/nodes/_service/singletonEngineering";
import MathEngine from "../../../flowchart/utils/MathEngine";
import Mapping from "./Mapping";


class KPI extends Mapping {
  constructor(newKpiS = {}, newKpiR = {}) {
    super({...newKpiS})

    this.idReal = newKpiR.id ? newKpiR.id : 0
    this.mappingReal = newKpiR.mapping ? newKpiR.mapping : "ind_real_produto"
    this.valueTarget = newKpiS.value ? newKpiS.value :  "0,00"
    this.valueReal = newKpiR.value ? newKpiS.value :  "0,00"

    this.clone = function() {
      return new KPI({...this, operation: 'papkps'}, {...this, id: this.idReal, mapping: this.mappingReal, operation: 'papkpr'})
    }

    this.setValue = function(){
      if(SingletonEnginnering.isLoaded){
        let result = MathEngine.sentence(this.mapping)
        this.valueTarget = NumberFormatToNode(result.value)
        return this.valueTarget
      }
      else{
        let that = this
        setTimeout(that.setValue, 1000)
      }

    }

    this.getMappings = function(){
      return [
        new Mapping({...this, operation: 'papkps' }),
        new Mapping({...this,  id: this.idReal, mapping: this.mappingReal, operation: 'papkpr' }),
      ]
    }
  }
}

export default KPI